const usersKeys = {
  module: ['users'] as const,
  list: () => [...usersKeys.module, 'list'] as const,
  listWithFilters: (filters: any) => [...usersKeys.list(), filters] as const,
  details: (id: string) => [...usersKeys.module, 'details', id] as const,
  profile: () => [...usersKeys.module, 'profile'],
};

export default usersKeys;
